import React from "react";
import "./About.css";
import { Type } from "./Type";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
// import TwitterIcon from "@mui/icons-material/Twitter";
// import DescriptionIcon from "@mui/icons-material/Description";
import { Introduction } from "./Introduction";
import { Timeline } from "./Timeline";
import { Techstacks } from "./Techstacks";
import Aman_Jaiswal_resume from '../../assets/resume/Aman.pdf';
export const About = () => {
  return (
    <>
      <div className="about center">
        <h1 data-aos="fade-right" className="mobileHead">
          Hello, I am <span className="about__name">Aman Jaiswal</span>
          <span className="about__role">
            Frontend Developer — Angular, React &amp; TypeScript
          </span>
        </h1>
        <Type />

        <p className="about__desc" data-aos="fade-right">
          I am <strong>Aman Jaiswal</strong>, a{" "}
          <strong>frontend developer</strong> based in Indore, India, with 3+
          years of experience building web applications in{" "}
          <strong>Angular</strong>, <strong>React</strong> and{" "}
          <strong>TypeScript</strong>. The browser is where I do my best work —
          component architecture, state management, responsive layouts and
          performance — and I am comfortable across the stack with Node.js,
          Express and MySQL.
          <br /><br />
          As an Angular developer I have shipped real-time features such as live
          chat with Socket.IO and video calling with WebRTC, added secure login
          with OAuth, and kept code quality measurable with SonarQube. I write
          clean, readable, well-typed code that other developers can pick up
          without a handover call.
          <br /><br />
          My work spans a FinTech earned-wage platform, a sports social
          community, a travel booking system and a video-based job portal. I
          enjoy solving problems, working in teams, and building products people
          actually use.
        </p>

        <div className="about__contact center">
          <a
            href="https://github.com/AMAN-JAISWALL"
            aria-label="Aman Jaiswal on GitHub"
            title="Aman Jaiswal on GitHub"
            target="_blank"
            rel="me noopener noreferrer"
            className="link link--icon"
          >
            <GitHubIcon />
          </a>
          <a
            href="mailto:aj27757@gmail.com"
            aria-label="Email Aman Jaiswal, frontend developer"
            title="Email Aman Jaiswal"
            className="link link--icon"
          >
            <EmailIcon />
          </a>
          <a
            href="tel:+917974999575"
            aria-label="Call Aman Jaiswal"
            title="Call Aman Jaiswal"
            className="link link--icon"
          >
            <PhoneIcon />
          </a>
          <a
            href="https://www.linkedin.com/in/aman-jaiswal-39a9b1254/"
            aria-label="Aman Jaiswal on LinkedIn"
            title="Aman Jaiswal on LinkedIn"
            className="link link--icon"
            target="_blank"
            rel="me noopener noreferrer"
          >
            <LinkedInIcon />
          </a>
        </div>

        <a
          className="btnResume"
          href={Aman_Jaiswal_resume}
          target="_blank"
          rel="noreferrer"
          aria-label="Download the resume of Aman Jaiswal, Angular and React developer"
          title="Resume — Aman Jaiswal, Frontend Developer (Angular & React)"
        >
          Resume
        </a>
      </div>
      <Introduction />
      <Timeline />
      <section id="skills" aria-labelledby="skills-heading">
        <Techstacks />
      </section>
      <br />
      <br />
      
    </>
  );
};
